import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatApiError } from "../context/AuthContext";
import { SignIn, Sparkle } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back!");
      navigate(loc.state?.from?.pathname || "/dashboard", { replace: true });
    } catch (e) {
      toast.error(formatApiError(e, "Login failed"));
    } finally {
      setLoading(false);
    }
  };

  const useDemo = () => {
    setEmail("demo@reflip.app");
    setPassword("demo1234");
  };

  return (
    <div className="mx-auto max-w-md px-6 py-16">
      <div className="nb-card bg-white">
        <span className="nb-label">Welcome back</span>
        <h1 className="mt-2 font-display text-4xl font-black tracking-tighter">Log in</h1>
        <p className="mt-2 text-sm font-medium text-[#4A4A4A]">
          Buy from sellers, list your own items, and track every flip.
        </p>
        <form className="mt-6 space-y-4" onSubmit={onSubmit}>
          <div>
            <label className="nb-label">Email</label>
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="nb-input mt-2"
            />
          </div>
          <div>
            <label className="nb-label">Password</label>
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="nb-input mt-2"
            />
          </div>
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="nb-btn flex w-full items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading ? <Sparkle className="animate-spin" /> : <SignIn weight="bold" size={18} />} Log in
          </button>
        </form>
        <div className="mt-4 flex items-center justify-between text-xs font-bold uppercase tracking-wider">
          <button
            data-testid="use-demo"
            type="button"
            onClick={useDemo}
            className="underline hover:no-underline"
          >
            Use demo account
          </button>
          <Link to="/register" className="underline hover:no-underline">
            Need an account?
          </Link>
        </div>
      </div>
    </div>
  );
}
